<div *ngIf="popupName =='Create Email Body for Employment application'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Application Invite mail to Emp</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <div [innerHTML]="employeeApplicationEmailBody" style="display: none;"></div>
          <!-- 
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
           <span> #EMPLOYEE_NAME#</span><span>  <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."></span>
         
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" class="no-insert"
                (click)="subjectclick('subject')" placeholder="Enter Subject Here...">
            </div>
          </mat-form-field>
        </ion-col>


        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12" class="button-container">
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->


          <button (click)="saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content fixed-width" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
        </ion-col>


      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <!-- <div>
            <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"></angular-editor>
          </div> -->
          <div>

            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME#')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor #editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')">
            </angular-editor> -->
            <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
            <!-- Instead of *ngIf="condition" -->


          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Create Email Body for Intimation email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Intimation Mail to HR
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>

            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Create Email Body for offer letter email'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Offer letter mail</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput  type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)="saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create Email Body for Appoinment letter issuance'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Appointment Letter Mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)=" saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Confirmation letter mail with no change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Confirmation letter mail(with no change)
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)=" saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='confirmation with change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Confirmation letter mail(with change)
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Extention of probation letter mail'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Extention of probation letter mail
            </p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <!-- <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here...">
          </mat-form-field> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <div class="d-flex">
              <p class="employee-name" style="color: black;margin-top: 2px;">{{emplyeeName}}</p>
              <input matInput type="text" [(ngModel)]="invitationEmailSubject" placeholder="Enter Subject Here..."
                (click)="subjectclick('subject')">
            </div>
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)="saveMaildata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMaildata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                  [style.background-color]="green">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"  [style.background-color]="green">Dear</button> -->
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="employeeApplicationEmailBody"
              (click)="subjectclick('body')"></jodit-editor>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create offer letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Offer letter content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
              (click)="subjectclick('subject')">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <!-- <button *ngIf="!isPublished" (click)="saveMailContentdata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button> -->
          <button type="button" class="add_btn fs-14 fixed-width"
            (click)=" saveMailContentdata()">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                [ngClass]="'green-bg'">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"
                  [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14" (click)="addToEditor('#Grade#')"
                [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Band#')"
                [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date#')"
                  [ngClass]="'green-bg'">#Date#</button>
                 
                  <button class="back_btn fs-14" (click)="addToEditor('#Address#')"
                  [ngClass]="'green-bg'">#Address#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#HR_EMAIL#')"
                  [ngClass]="'green-bg'">#HR_EMAIL#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date_Of_Joining#')"
                  [ngClass]="'green-bg'">#Date_Of_Joining#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#workLocationCity#')"
                  [ngClass]="'green-bg'">#workLocationCity#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#workLocationState#')"
                  [ngClass]="'green-bg'">#workLocationState#'</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#COMPANY_NAME#')"
                  [ngClass]="'green-bg'">#COMPANY_NAME#</button>
              </ion-col>
            </ion-row>
           <jodit-editor id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig" (click)="subjectclick('body')"></jodit-editor>

            
            

            


            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody" (click)="subjectclick('body')"></angular-editor> -->
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>

<div *ngIf="popupName =='Create Appoinment letter content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Appointment Letter content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
              (click)="subjectclick('subject')">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button (click)="saveMailContentdata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                [ngClass]="'green-bg'">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"
                  [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14" (click)="addToEditor('#Grade#')"
                [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Band#')"
                [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date#')"
                  [ngClass]="'green-bg'">#Date#</button>
               
                  <button class="back_btn fs-14" (click)="addToEditor('#Address#')"
                  [ngClass]="'green-bg'">#Address#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#HR_EMAIL#')"
                  [ngClass]="'green-bg'">#HR_EMAIL#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date_Of_Joining#')"
                  [ngClass]="'green-bg'">#Date_Of_Joining#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#workLocationCity#')"
                  [ngClass]="'green-bg'">#workLocationCity#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#workLocationState#')"
                  [ngClass]="'green-bg'">#workLocationState#'</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#COMPANY_NAME#')"
                  [ngClass]="'green-bg'">#COMPANY_NAME#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig" (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Confirmation letter content with no change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Confirmation letter content with no change</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
              (click)="subjectclick('subject')">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)="saveMailContentdata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME# ')"
                [ngClass]="'green-bg'">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"
                  [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14" (click)="addToEditor('#Grade#')"
                [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Band#')"
                [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Total CTC#')"
                [ngClass]="'green-bg'">#Total CTC#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date#')"
                  [ngClass]="'green-bg'">#Date#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig" (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Confirmation letter content with change'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Confirmation letter content with change</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
              (click)="subjectclick('subject')">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)="saveMailContentdata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME#')"
                [ngClass]="'green-bg'">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"
                  [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14" (click)="addToEditor('#Grade#')"
                [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Band#')"
                [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Total_CTC#')"
                [ngClass]="'green-bg'">#Total_CTC#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date#')"
                  [ngClass]="'green-bg'">#Date#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#dateOfConfirmation#')"
                  [ngClass]="'green-bg'">#dateOfConfirmation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date_Of_Joining#')"
                  [ngClass]="'green-bg'">#Date_Of_Joining#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#employeeCode#')"
                  [ngClass]="'green-bg'">#employeeCode#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#COMPANY_NAME#')"
                  [ngClass]="'green-bg'">#COMPANY_NAME#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig" (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
<div *ngIf="popupName =='Extention of probation content'">
  <div class="cardLayoutTwo">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="popup-heading">
          <div class="verticle-center">
            <p class="fs-16 font_regular">Extention of probation content</p>
          </div>
          <div class="popup-close">
            <span (click)="onClickCloseInvitation()"
              class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="cardBoxTwo">
      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="1" size-lg="1" size-xs="12">
          <div class="fs-16 font_semibold">Subject:</div>
        </ion-col>

        <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
          <mat-form-field class="w-100 mat-height40 mat-input-style pl-10">
            <input matInput type="text" [(ngModel)]="letterContentsubject" placeholder="Enter Subject Here..."
              (click)="subjectclick('subject')">
          </mat-form-field>
        </ion-col>

        <ion-col size-sm="12" size-md="2" size-lg="2" size-xs="12">
          <button  (click)="saveMailContentdata()" type="button"
            class="add_btn fs-14 float-right center-content" [style.background-color]="buttonColorName">
            <span class="material-icons fs-16 mr-5">send</span>
            Save
          </button>
          <!-- <button type="button" class="add_btn fs-14 fixed-width"
            (click)="isEditing ? saveMailContentdata() : toggleEditMode()">
            <span class="material-icons fs-16 mr-5">{{ isEditing ? 'send' : 'edit' }}</span>
            {{ isEditing ? 'Save' : 'Edit' }}
          </button> -->
        </ion-col>
      </ion-row>

      <ion-row class="verticle-center mt-10">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div>
            <ion-row>
              <ion-col size="12" class=" mb-10">
                <button class="back_btn fs-14" (click)="addToEditor('#EMPLOYEE_NAME#')"
                [ngClass]="'green-bg'">#EMPLOYEE_NAME#</button>
                <!-- <button class="back_btn fs-14" (click)="addToEditor('Dear')"
                  [style.background-color]="green">Dear</button> -->
                <button class="back_btn fs-14" (click)="addToEditor('#Grade#')"
                [ngClass]="'green-bg'">#Grade#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Band#')"
                [ngClass]="'green-bg'">#Band#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Designation#')"
                [ngClass]="'green-bg'">#Designation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Department#')"
                  [ngClass]="'green-bg'">#Department#</button>
                <button class="back_btn fs-14" (click)="addToEditor('#Total_CTC#')"
                [ngClass]="'green-bg'">#Total_CTC#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date#')"
                  [ngClass]="'green-bg'">#Date#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#dateOfConfirmation#')"
                  [ngClass]="'green-bg'">#dateOfConfirmation#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#Date_Of_Joining#')"
                  [ngClass]="'green-bg'">#Date_Of_Joining#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#employeeCode#')"
                  [ngClass]="'green-bg'">#employeeCode#</button>
                  <button class="back_btn fs-14" (click)="addToEditor('#COMPANY_NAME#')"
                  [ngClass]="'green-bg'">#COMPANY_NAME#</button>
              </ion-col>
            </ion-row>
            <!-- <angular-editor id="htmlDiv" [config]="editorConfig" [(ngModel)]="letterContentBody"
              (click)="subjectclick('body')"></angular-editor> -->
              <jodit-editor id="htmlDiv" [(ngModel)]="letterContentBody" [config]="editorConfig" (click)="subjectclick('body')"></jodit-editor>

          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>